import { createSelector } from '@ngrx/store';

import { selectPreferencesState } from './preferences.selectors';
import { artistAdapter } from '../adapters';

export const selectArtistState = createSelector(selectPreferencesState, (preferencesState) => preferencesState.artists);

export const selectArtistsLoading = createSelector(selectArtistState, (artistState) => artistState.loading);

export const selectCanLoadMoreArtists = createSelector(selectArtistState, (artistState) => artistState.nextPage);

export const selectArtistInitialFilter = createSelector(selectArtistState, (artistState) => artistState.initialFilter);

export const selectFollowingFilter = createSelector(selectArtistState, (artistState) => artistState.followingFilter);

export const selectArtists = createSelector(selectArtistState, artistAdapter.getSelectors().selectAll);
